import * as Yup from "yup";

const componentSchema = Yup.object({
  type: Yup.string().required("Type is required").trim(),
  category: Yup.string().required("Category is required").trim(),
  amount: Yup.number()
    .typeError("Amount must be a number")
    .required("Amount is required")
    .moreThan(0, "Amount must be greater than 0"),
});

const schema = Yup.object({
  effectiveFrom: Yup.string().required("Effective from is required"),
  effectiveTo: Yup.string().nullable().optional(),
  components: Yup.array()
    .of(componentSchema)
    .min(1, "At least one component is required")
    .required()
    .test(
      "deductions-not-exceed-earnings",
      "Total deductions cannot exceed total earnings",
      (components) => {
        const rows = components ?? [];
        const totalEarnings = rows
          .filter((c) => c?.category === "EARNING")
          .reduce((sum, c) => sum + (Number(c?.amount) || 0), 0);
        const totalDeductions = rows
          .filter((c) => c?.category === "DEDUCTION")
          .reduce((sum, c) => sum + (Number(c?.amount) || 0), 0);
        return totalDeductions <= totalEarnings;
      },
    ),
}).test(
  "effective-range",
  "Effective to must be on or after effective from",
  function (vals) {
    const from = vals.effectiveFrom;
    const to = vals.effectiveTo;
    if (!from || !to || String(to).trim() === "") return true;
    return String(to) >= String(from);
  },
);

export default schema;
